var __defProp = Object.defineProperty;
var __defNormalProp = (obj, key, value) => key in obj ? __defProp(obj, key, { enumerable: true, configurable: true, writable: true, value }) : obj[key] = value;
var __publicField = (obj, key, value) => __defNormalProp(obj, typeof key !== "symbol" ? key + "" : key, value);

export { __publicField };
//# sourceMappingURL=chunk-NSSMTXJJ.mjs.map
//# sourceMappingURL=chunk-NSSMTXJJ.mjs.map